import { PhCards } from '@phosphor-icons/vue'

import { websiteBlockMethods } from '@/features/website-builder/builder/blocks/common/methods'
import { type BuilderBlockModule } from '@/lib/builder/types'
import i18nPlugin from '@/plugins/i18n'

import {
  type CardsSection,
  type CardsSectionCreate,
  type CardsSectionUpdate,
  type WebsiteResource,
} from '../../WebsiteBuilder.types'

import CardsEditor from './editor/CardsEditor.vue'
import { createCardsData } from './methods/createCardsData'
import CardsPreview from './preview/CardsPreview.vue'

const i18n = i18nPlugin.global

export const CardsBlockModule: BuilderBlockModule<
  CardsSection,
  CardsSectionCreate,
  CardsSectionUpdate,
  WebsiteResource
> = {
  createData: createCardsData,
  customEditor: true,
  editor: CardsEditor,
  meta: [
    {
      icon: PhCards,
      key: 'cards',
      label: i18n.t('website-builder.blocks.cards'),
      sort: 4,
    },
  ],
  methods: websiteBlockMethods,
  preview: CardsPreview,
}
